import { __decorate, __extends } from "tslib";
import { inject, observer } from 'mobx-react';
import React from 'react';
import { deleteMedia } from '../api/medias';
import { customConfirm } from '../utils/utils';
import { Button } from './Button';
import S from './MediaItem.styl';
var MediaItem = /** @class */ (function (_super) {
    __extends(MediaItem, _super);
    function MediaItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
        };
        _this.deleteItem = function () {
            var i18n = _this.props.store.i18n;
            var media = _this.props.media;
            if (media) {
                customConfirm(i18n.mediasDeleteSummary, _this.props.store, function (success) {
                    if (success) {
                        _this.setState({ loading: true });
                        var request = {
                            id: media.id,
                        };
                        deleteMedia(request).then(function () {
                            _this.setState({ loading: false });
                            _this.isUpdated();
                        }).catch(function (error) {
                            _this.setState({ loading: false });
                            alert(error);
                        });
                    }
                });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        return _this;
    }
    MediaItem.prototype.componentDidMount = function () {
        // Did Mount
    };
    MediaItem.prototype.render = function () {
        var props = this.props;
        var media = props.media;
        var i18n = props.store.i18n;
        return (React.createElement("div", { className: S.mediaItem }, media ?
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: S.tableCell },
                    React.createElement("img", { src: media.url })),
                React.createElement("div", { className: S.tableCell + ' ' + S.image },
                    React.createElement("a", { href: media.url, target: "_blank" }, media.url)),
                React.createElement("div", { className: S.action },
                    React.createElement(Button, { className: S.deleteButton, type: "button", onClick: this.deleteItem }, i18n.actionDelete)))
            :
                React.createElement(React.Fragment, null)));
    };
    MediaItem = __decorate([
        inject('store'),
        observer
    ], MediaItem);
    return MediaItem;
}(React.Component));
export { MediaItem };
